var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmarkCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66667 10C1.66667 5.39763 5.39763 1.66667 10 1.66667C12.2101 1.66667 14.3298 2.54464 15.8926 4.10744C17.4554 5.67025 18.3333 7.78986 18.3333 10C18.3333 14.6024 14.6024 18.3333 10 18.3333C5.39763 18.3333 1.66667 14.6024 1.66667 10ZM8.94167 12.7917L13.625 8.10834C13.7784 7.94738 13.7784 7.69429 13.625 7.53333L13.1833 7.09167C13.0213 6.93286 12.762 6.93286 12.6 7.09167L8.65001 11.0417L7.40001 9.8C7.32439 9.71944 7.21883 9.67374 7.10834 9.67374C6.99785 9.67374 6.89228 9.71944 6.81667 9.8L6.37501 10.2417C6.29612 10.3199 6.25176 10.4264 6.25176 10.5375C6.25176 10.6486 6.29612 10.7551 6.37501 10.8333L8.35834 12.7917C8.43395 12.8722 8.53952 12.9179 8.65001 12.9179C8.76049 12.9179 8.86606 12.8722 8.94167 12.7917Z",
    fill: "#0BB07B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkCircle);
export default __webpack_public_path__ + "static/media/checkmark_circle.892ed68a1413a3443e2531a83cdf8db9.svg";
export { ForwardRef as ReactComponent };